import {keyframes, styled} from "@mui/material/styles";
import {Box} from "@mui/material";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

export const ShimmerContainer = styled(Box)(({theme}) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}));

export const ShimmerEffect = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    background: 'linear-gradient(to right, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.05) 100%)',
    backgroundSize: '936px 100%',
    animation: `${shimmer} 1.5s infinite linear`,
    position: 'relative',
    overflow: 'hidden',
}));